import { render, staticRenderFns } from "./SvCheckbox.vue?vue&type=template&id=ab20ac78&"
import script from "./SvCheckbox.vue?vue&type=script&lang=js&"
export * from "./SvCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports